import React from 'react';
const bonuses = [{
  title: 'SENIOR BALANCE & FALL PREVENTION SYSTEM™',
  description: "Un sistema professionale dedicato al miglioramento dell'equilibrio e alla prevenzione delle cadute. Include protocolli completi, circuiti progressivi, esercizi organizzati per livello funzionale, sessioni individuali e di gruppo, progressioni già pronte, criteri di avanzamento e strumenti pratici per integrare facilmente il lavoro sull'equilibrio in qualsiasi programma di allenamento."
}, {
  title: 'FUNCTIONAL CIRCUIT BUILDER™',
  description: 'Una raccolta professionale di circuiti funzionali completamente sviluppati per clienti senior. Include strutture già pronte per forza, mobilità, resistenza, coordinazione, equilibrio e condizionamento generale, con tempi, stazioni, recuperi, progressioni e adattamenti già organizzati per lavorare con gruppi o lezioni individuali.'
}, {
  title: 'SENIOR SMALL GROUP COACHING SYSTEM™',
  description: 'Un sistema completo per gestire gruppi di adulti senior con livelli differenti. Include modelli di lezione, organizzazione degli spazi, rotazione delle stazioni, adattamenti immediati, gestione del gruppo, controllo della partecipazione e strumenti professionali per offrire lezioni sicure, dinamiche ed efficaci.'
}, {
  title: 'PROFESSIONAL EXERCISE PROGRESSIONS™',
  description: 'Una libreria completa di progressioni professionali per i principali movimenti utilizzati nel fitness senior. Include regressioni, varianti, sostituzioni e livelli di difficoltà già organizzati per adattare rapidamente ogni esercizio mantenendo una progressione logica e sicura durante tutto il percorso del cliente.'
}, {
  title: 'ANNUAL PROGRAMMING PLANNER™',
  description: 'Planner professionali annuali con programmazione mensile e settimanale, distribuzione degli obiettivi, organizzazione dei cicli di allenamento, monitoraggio dei progressi, gestione del volume di lavoro e modelli pronti per pianificare l\'intero anno senza dover ricominciare ogni volta da zero.'
}];
const changes = [{
  emoji: '⚡',
  title: 'Risparmia Ore Ogni Settimana',
  description: 'Smetti di creare lezioni, programmi, adattamenti e documentazione da zero. Apri il sistema. Scegli il materiale. Personalizzalo se necessario. E prepara ogni allenamento in pochi minuti.'
}, {
  emoji: '👑',
  title: 'Lavora con Maggiore Professionalità',
  description: 'Organizza ogni lezione con un sistema completo composto da sessioni, programmi, esercizi, valutazioni e strumenti professionali già pronti. Offri ai tuoi clienti un metodo di lavoro più organizzato, efficace e professionale.'
}, {
  emoji: '💪',
  title: 'Aiuta i Tuoi Clienti a Ottenere Risultati Migliori',
  description: 'Utilizza programmi progressivi, lezioni già strutturate e sistemi di pianificazione professionali che ti permettono di seguire ogni cliente con maggiore continuità, sicurezza ed efficacia durante tutto il percorso.'
}, {
  emoji: '😊',
  title: 'Concentrati Finalmente Sul Coaching',
  description: 'Dedica meno tempo alla preparazione delle lezioni e più tempo ad allenare, motivare, correggere e seguire i tuoi clienti. È questo il vero lavoro di un allenatore.'
}];
export function BonusSection() {
  return <>
      <section className="py-8 px-4 sm:px-6 bg-petrol text-white" data-id="element-15" data-mp="3rncvp3iopw0s">
        <h2 className="text-xl sm:text-3xl font-heading font-extrabold text-center text-gold leading-tight uppercase mb-5" data-id="element-16" data-mp="jafeagbxtf9r">
          🎁 In Più Riceverai 5 Bonus Esclusivi
        </h2>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 max-w-4xl mx-auto" data-id="element-17" data-mp="9aolcj30z8bs">
          {bonuses.map((bonus, i) => <div key={bonus.title} className={`bg-petrol-dark border border-gold/40 p-4 rounded-lg ${i === 4 ? 'sm:col-span-2' : ''}`} data-id="element-18" data-mp="e8yfcqd0k2vt" data-mpi={i}>
              <p className="inline-block bg-gold/20 text-gold font-heading font-bold text-[10px] px-2 py-1 rounded mb-2 tracking-widest uppercase" data-id="element-19" data-mp="2z1tiigeiumj6">
                🎁 BONUS {i + 1}
              </p>
              <h3 className="text-sm sm:text-base font-heading font-bold text-white mb-1.5 leading-tight" data-id="element-20" data-mp="3agof2gnblmy1">
                {bonus.title}
              </h3>
              <p className="text-[13px] sm:text-sm text-cream/85 leading-relaxed" data-id="element-21" data-mp="30ja7l6jdk8hv">
                {bonus.description}
              </p>
            </div>)}
        </div>
      </section>

      <section className="py-8 px-4 sm:px-6 bg-cream" data-id="element-22" data-mp="3t7xzvm2jjy4x">
        <h2 className="text-xl sm:text-3xl font-heading font-extrabold text-center text-petrol leading-tight uppercase mb-5" data-id="element-23" data-mp="3t8h8gc6axa6a">
          Cosa Cambierà da Oggi
        </h2>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 max-w-4xl mx-auto" data-id="element-24" data-mp="3jajink8sn5bk">
          {changes.map(item => <div key={item.title} className="bg-white border-l-4 border-sage p-4 rounded-r-lg shadow-sm" data-id="element-25" data-mp="2cuh9p4j6zqkm">
              <h3 className="text-sm sm:text-base font-heading font-bold text-petrol mb-1.5 leading-snug" data-id="element-26" data-mp="nckgtch2v2ev">
                <span aria-hidden="true" data-id="element-27" data-mp="sbdsczct0jce">{item.emoji}</span> {item.title}
              </h3>
              <p className="text-warmgray text-[13px] sm:text-sm leading-relaxed" data-id="element-28" data-mp="xaqgdnfevwgk">
                {item.description}
              </p>
            </div>)}
        </div>
      </section>
    </>;
}